

import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Fab, Grid, Paper, Skeleton, Stack, Typography } from '@mui/material'


import OverallWellnessScore from "../personalreport/OverallWellnessScore";

//import KeyAreaNavBar from "./partials/personalreport/KeyAreaNavBar";
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import { useReactToPrint } from "react-to-print";



import HealthAge from "../personalreport/HealthAge";
import Information from "../personalreport/Information";
import HelpIconPopover from "../HelpIconPopover";
import WellnessScore from "../WellnessScore";

const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 0 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const WellnessScoreSingle = (props) => {
    const { component } = props
    const { settings, PrintView } = props.otherprops

    return (

        <Box>
            {component.HelpText !== '' && (
                <Stack direction={"column"} spacing={2}>

                <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                    {component.Label}
                </Typography>
                    <HelpIconPopover Text={component.HelpText} style={{ top: '-10!important' }} />
                </Stack>
            )}

            <Box class="OWS">
                <Box class="OWSCircle">
                    <WellnessScore OWSText={'test'} CurrentOWSValue={component.Score} HealthAge={null} />
                </Box>
            </Box>
        </Box>

    )

}

export default WellnessScoreSingle